import { render, staticRenderFns } from "./Book2.vue?vue&type=template&id=b3c63624&scoped=true"
import script from "./Book2.vue?vue&type=script&lang=js"
export * from "./Book2.vue?vue&type=script&lang=js"
import style0 from "./Book2.vue?vue&type=style&index=0&id=b3c63624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c63624",
  null
  
)

export default component.exports